import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../html/element'
import { Icon } from '../../../../html/icon'
import { SCORE_MODE_ID } from '../../../constant'
import {
  resetStoreScoreCredit,
  resetStoreScorePerformance,
  selectDataScoreLevelRange,
  selectScore,
} from '../../../store/sliceScoreLevel'
import { DISPLAY_SCORE } from '../../constant'
import { handleDisplayScore } from '../../helper'
import styles from '../index.module.scss'

export const GroupDisplayScore = ({ isShowTable, isShowSidebar }) => {
  const dispatch = useDispatch()

  const scoreRange = useSelector(selectDataScoreLevelRange)

  //credit
  const scoreCreditCurrent = useSelector(
    selectScore(['creditScore', 'current']),
  )
  const scoreCreditPrev = useSelector(selectScore(['creditScore', 'previous']))
  const displayCreditCurrent = handleDisplayScore(
    scoreRange[SCORE_MODE_ID.CORPORATE_RISK],
    scoreCreditCurrent,
  )
  const displayCreditPrev = handleDisplayScore(
    scoreRange[SCORE_MODE_ID.CORPORATE_RISK],
    scoreCreditPrev,
  )

  //performance
  const scorePerformanceCurrent = useSelector(
    selectScore(['performanceScore', 'current']),
  )
  const scorePerformancePrev = useSelector(
    selectScore(['performanceScore', 'previous']),
  )
  const displayPerformanceCurrent = handleDisplayScore(
    scoreRange[SCORE_MODE_ID.PERFORMANCE],
    scorePerformanceCurrent,
  )
  const displayPerformancePrev = handleDisplayScore(
    scoreRange[SCORE_MODE_ID.PERFORMANCE],
    scorePerformancePrev,
  )

  //Actions
  const handelClearCreditCurrent = () => {
    dispatch(resetStoreScoreCredit('current'))
  }
  const handelClearCreditPrev = () => {
    dispatch(resetStoreScoreCredit('previous'))
  }
  const handelClearPerformanceCurrent = () => {
    dispatch(resetStoreScorePerformance('current'))
  }
  const handelClearPerformancePrev = () => {
    dispatch(resetStoreScorePerformance('previous'))
  }

  if (
    !displayCreditCurrent.isShow &&
    !displayCreditPrev.isShow &&
    !displayPerformanceCurrent?.isShow &&
    !displayPerformancePrev?.isShow
  ) {
    return null
  }

  if (isShowTable) {
    return (
      <>
        <Element
          className="dFlex gap5"
          style={{
            backgroundColor: '#F3F3F3',
            padding: '8px 12px',
          }}
        >
          <Element
            elementName="span"
            className="fw600 "
            style={{
              width: 120,
            }}
          >
            <Translate value="library.filterSetting.SCORE_LEVEL_TITLE" />
          </Element>
          <div className="flex1" id="displayScore">
            {!!displayCreditCurrent.isShow && (
              <ItemDisplayScoreInTable
                text="library.filterCompanies.CURRENT_CREDIT"
                range={displayCreditCurrent?.rangeScore}
              />
            )}
            {!!displayCreditPrev?.isShow && (
              <ItemDisplayScoreInTable
                text="library.filterCompanies.PREV_CREDIT"
                range={displayCreditPrev?.rangeScore}
              />
            )}

            {!!displayPerformanceCurrent?.isShow && (
              <ItemDisplayScoreInTable
                text="library.filterCompanies.CURRENT_PER"
                range={displayPerformanceCurrent.rangeScore}
              />
            )}
            {!!displayPerformancePrev?.isShow && (
              <ItemDisplayScoreInTable
                text="library.filterCompanies.PREV_PER"
                range={displayPerformancePrev?.rangeScore}
              />
            )}
          </div>
        </Element>
      </>
    )
  }

  if (isShowSidebar) {
    const objFilter = {
      [DISPLAY_SCORE.CREDIT_CURRENT]: {
        isShow: displayCreditCurrent.isShow,
        component: () => (
          <Translate
            value="library.filterCompanies.CURRENT_CREDIT"
            range={`${displayCreditCurrent?.rangeScore}`}
          />
        ),
      },
      [DISPLAY_SCORE.CREDIT_PREV]: {
        isShow: displayCreditPrev.isShow,
        component: () => (
          <Translate
            value="library.filterCompanies.PREV_CREDIT"
            range={`${displayCreditPrev?.rangeScore} `}
          />
        ),
      },
      [DISPLAY_SCORE.PERFORMANCE_CURRENT]: {
        isShow: displayPerformanceCurrent.isShow,
        component: () => (
          <Translate
            value="library.filterCompanies.CURRENT_PER"
            range={`${displayPerformanceCurrent.rangeScore}`}
          />
        ),
      },
      [DISPLAY_SCORE.PERFORMANCE_PREV]: {
        isShow: displayPerformancePrev.isShow,
        component: () => (
          <Translate
            value="library.filterCompanies.PREV_PER"
            range={displayPerformancePrev?.rangeScore}
          />
        ),
      },
    }
    const listScoreShow = Object.keys(objFilter).filter(
      (item) => objFilter[item].isShow,
    )

    return (
      <>
        <Translate value="library.filterSetting.SCORE_LEVEL" />
        :&nbsp;
        {listScoreShow.map((item, index) => {
          return (
            <Fragment key={index}>
              {objFilter[item].component()}
              {index === 0 && listScoreShow.length > 1 && <>,&nbsp;</>}
              {index !== 0 && index !== listScoreShow.length - 1 && (
                <>,&nbsp;</>
              )}
            </Fragment>
          )
        })}
      </>
    )
  }

  return (
    <div
      className={[styles.groupCriteria].join(' ')}
      style={{ display: 'flex' }}
    >
      <div className={styles.title}>
        <Translate value="library.filterSetting.SCORE_LEVEL_TITLE" />
      </div>

      <div
        className="dFlex flex1 gap1"
        style={{ flexWrap: 'wrap', textTransform: 'capitalize' }}
      >
        {!!displayCreditCurrent.isShow && (
          <ItemDisplayScore
            text="library.filterCompanies.CURRENT_CREDIT"
            range={displayCreditCurrent?.rangeScore}
            onDelete={handelClearCreditCurrent}
          />
        )}
        {!!displayCreditPrev.isShow && (
          <ItemDisplayScore
            text="library.filterCompanies.PREV_CREDIT"
            range={displayCreditPrev?.rangeScore}
            onDelete={handelClearCreditPrev}
          />
        )}
        {!!displayPerformanceCurrent?.isShow && (
          <ItemDisplayScore
            text="library.filterCompanies.CURRENT_PER"
            range={displayPerformanceCurrent?.rangeScore}
            onDelete={handelClearPerformanceCurrent}
          />
        )}
        {!!displayPerformancePrev?.isShow && (
          <ItemDisplayScore
            text="library.filterCompanies.PREV_PER"
            range={displayPerformancePrev?.rangeScore}
            onDelete={handelClearPerformancePrev}
          />
        )}
      </div>
    </div>
  )
}

export const ItemDisplayScore = ({ text, range, onDelete }) => {
  return (
    <div className={styles.content}>
      <Element
        className={styles.item}
        style={{ backgroundColor: '#F3F3F3', borderColor: '#E5E5E8' }}
      >
        <Element
          style={{
            color: '#191D25',
            whiteSpace: 'nowrap',
          }}
        >
          <Translate value={text} range={range} />
        </Element>

        <Icon
          className="icon-delete-circle-fill"
          style={{ color: '#9C9C9C' }}
          onClick={onDelete}
        />
      </Element>
    </div>
  )
}

const ItemDisplayScoreInTable = ({ text, range }) => {
  return (
    <Element
      style={{
        color: '#191D25',
      }}
    >
      <Translate value={text} range={range} />
    </Element>
  )
}

GroupDisplayScore.propTypes = {
  isShowTable: PropTypes.bool,
  isShowSidebar: PropTypes.bool,
}

GroupDisplayScore.defaultProps = {
  isShowTable: false,
  isShowSidebar: false,
}
